import { Link } from '@suntex.core/nav'

/**
 * returns JSX for not found
 */
function NotFound() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  )
}

export default NotFound
